import { clsx } from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: 'primary' | 'white' | 'gray';
}

const sizeClasses = {
  sm: { width: '1rem', height: '1rem' },
  md: { width: '1.5rem', height: '1.5rem' },
  lg: { width: '2rem', height: '2rem' },
  xl: { width: '3rem', height: '3rem' },
};

const colorClasses = {
  primary: 'text-primary',
  white: 'text-white',
  gray: 'text-muted',
};

export function LoadingSpinner({ 
  size = 'md', 
  className,
  color = 'primary'
}: LoadingSpinnerProps) {
  return (
    <div
      className={clsx(
        'spinner-border',
        colorClasses[color],
        className
      )}
      style={sizeClasses[size]}
      role="status"
      aria-label="Loading"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}